// import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import { apiService } from "../Config/api.service";

const EmployeeSelect = ({
    value,
    onChange,
    isDisabled = false,
    placeholder,
    minInputLength = 2,
    nameKey = "name",
    employeeId,
    ...props
}) => {
    const { t } = useTranslation();
    const resolvedPlaceholder = placeholder ?? t('employeeSelect.choosePlaceholder');
    const loadEmployeeOptions = async (inputValue, callback) => {
        if (!inputValue || inputValue.length < minInputLength) {
            callback([]);
            return;
        }
        try {
            // Corriger ici car le getElement ne recupere que le nbr de résultats par page
            const response = await apiService.getElement(`/employees?asearch=${encodeURIComponent(inputValue)}`);
            const employees = response.data.employees || [];
            callback(
                employees.map(emp => ({
                    value: emp.id,
                    label: emp[nameKey] || `${emp.name} ${emp.poste}`,
                }))
            );
        } catch (e) {
            callback([]);
        }
    };

    return (
        <AsyncSelect
            cacheOptions
            defaultOptions
            loadOptions={loadEmployeeOptions}
            value={value}
            onChange={onChange}
            placeholder={resolvedPlaceholder}
            isClearable
            isDisabled={isDisabled}
            noOptionsMessage={({ inputValue }) =>
                !inputValue || inputValue.length < minInputLength
                    ? t('employeeSelect.startTyping')
                    : t('tableList.noResultFound')
            }
            {...props}
        />
    );
};

export default EmployeeSelect;